<template>
  <div v-if="hasCorrected" class="ct-session-progress">
    <span class="ct-session-progress-label">Sesión</span>
    <div class="ct-session-pills">
      <button
        v-for="item in visibleItems"
        :key="item.slug"
        type="button"
        class="ct-session-pill"
        :class="{
          'is-done': item.corrected,
          'is-active': item.active,
          'is-blocked': item.blocked && !item.corrected,
        }"
        @click="onPillClick(item)"
      >
        {{ item.label }}
        <span v-if="item.corrected" class="ct-session-pill-mark" aria-hidden="true">✓</span>
      </button>
    </div>
  </div>
</template>

<script>
import { getSessionProgressItems } from "../utils/sessionProgress";

export default {
  name: "SessionProgress",
  props: {
    professionId: { type: String, required: true },
    testSlug: { type: String, required: true },
    session: { type: Object, required: true },
  },
  computed: {
    items() {
      return getSessionProgressItems(
        this.professionId,
        this.session,
        this.testSlug
      );
    },
    hasCorrected() {
      return this.items.some(function (item) {
        return item.corrected;
      });
    },
    visibleItems() {
      return this.items.filter(function (item) {
        return !item.blocked;
      });
    },
  },
  methods: {
    onPillClick(item) {
      // El activo no re-dispara cambio (re-seleccionarlo reiniciaría el form).
      if (item.active) return;
      this.$emit("select-test", item.slug);
    },
  },
};
</script>
